import {FETCHING_DATA_DONE, FETCHING_DATA_IN_PROGRESS} from '../../actions/generic/types';
import _ from 'lodash';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCHING_DATA_IN_PROGRESS:
      return true;
    case FETCHING_DATA_DONE:
      return false;
    default:
      return state;
  }
}